/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import './ww-echo-box.scss';
import { IWWEchoInt } from '../../common/model/graphql-types';
import { WWEchoImage } from './ww-echo-image';
import { Accordion } from 'react-bootstrap';
import { CustomPopover } from '../../cs/common/components/custom-popover';

interface IProps {
  echo: IWWEchoInt;
  level?: number[];
  onProfile?: boolean;
  inline?: boolean;
}

export const WWEchoBox: React.FC<IProps> = ({
  echo,
  level,
  onProfile,
  inline
}) => {
  const [finalEchoEffect, setFinalEchoEffect] = useState(null);

  useEffect(() => {
    let param0 = null;
    let param1 = null;
    let param2 = null;
    let param3 = null;
    let param4 = null;
    let param5 = null;
    let param6 = null;

    if (Number(level) === 1) {
      if (echo.Echo_skill.includes('{0}')) {
        param0 = echo.Skill_1[0];
      }

      if (echo.Echo_skill.includes('{1}')) {
        param1 = echo.Skill_1[1];
      }

      if (echo.Echo_skill.includes('{2}')) {
        param2 = echo.Skill_1[2];
      }

      if (echo.Echo_skill.includes('{3}')) {
        param3 = echo.Skill_1[3];
      }

      if (echo.Echo_skill.includes('{4}')) {
        param4 = echo.Skill_1[4];
      }

      if (echo.Echo_skill.includes('{5}')) {
        param5 = echo.Skill_1[5];
      }

      if (echo.Echo_skill.includes('{6}')) {
        param6 = echo.Skill_1[6];
      }
    }

    if (Number(level) === 2) {
      if (echo.Echo_skill.includes('{0}')) {
        param0 = echo.Skill_2[0];
      }

      if (echo.Echo_skill.includes('{1}')) {
        param1 = echo.Skill_2[1];
      }

      if (echo.Echo_skill.includes('{2}')) {
        param2 = echo.Skill_2[2];
      }

      if (echo.Echo_skill.includes('{3}')) {
        param3 = echo.Skill_2[3];
      }

      if (echo.Echo_skill.includes('{4}')) {
        param4 = echo.Skill_2[4];
      }

      if (echo.Echo_skill.includes('{5}')) {
        param5 = echo.Skill_2[5];
      }

      if (echo.Echo_skill.includes('{6}')) {
        param6 = echo.Skill_2[6];
      }
    }

    if (Number(level) === 3) {
      if (echo.Echo_skill.includes('{0}')) {
        param0 = echo.Skill_3[0];
      }

      if (echo.Echo_skill.includes('{1}')) {
        param1 = echo.Skill_3[1];
      }

      if (echo.Echo_skill.includes('{2}')) {
        param2 = echo.Skill_3[2];
      }

      if (echo.Echo_skill.includes('{3}')) {
        param3 = echo.Skill_3[3];
      }

      if (echo.Echo_skill.includes('{4}')) {
        param4 = echo.Skill_3[4];
      }

      if (echo.Echo_skill.includes('{5}')) {
        param5 = echo.Skill_3[5];
      }

      if (echo.Echo_skill.includes('{6}')) {
        param6 = echo.Skill_3[6];
      }
    }

    if (Number(level) === 4) {
      if (echo.Echo_skill.includes('{0}')) {
        param0 = echo.Skill_4[0];
      }

      if (echo.Echo_skill.includes('{1}')) {
        param1 = echo.Skill_4[1];
      }

      if (echo.Echo_skill.includes('{2}')) {
        param2 = echo.Skill_4[2];
      }

      if (echo.Echo_skill.includes('{3}')) {
        param3 = echo.Skill_4[3];
      }

      if (echo.Echo_skill.includes('{4}')) {
        param4 = echo.Skill_4[4];
      }

      if (echo.Echo_skill.includes('{5}')) {
        param5 = echo.Skill_4[5];
      }

      if (echo.Echo_skill.includes('{6}')) {
        param6 = echo.Skill_4[6];
      }
    }

    if (Number(level) === 5) {
      if (echo.Echo_skill.includes('{0}')) {
        param0 = echo.Skill_5[0];
      }

      if (echo.Echo_skill.includes('{1}')) {
        param1 = echo.Skill_5[1];
      }

      if (echo.Echo_skill.includes('{2}')) {
        param2 = echo.Skill_5[2];
      }

      if (echo.Echo_skill.includes('{3}')) {
        param3 = echo.Skill_5[3];
      }

      if (echo.Echo_skill.includes('{4}')) {
        param4 = echo.Skill_5[4];
      }

      if (echo.Echo_skill.includes('{5}')) {
        param5 = echo.Skill_5[5];
      }

      if (echo.Echo_skill.includes('{6}')) {
        param6 = echo.Skill_5[6];
      }
    }

    const newString = echo.Echo_skill.replaceAll(
      '{0}',
      `<strong>${param0}</strong>`
    )
      .replaceAll('{1}', `<strong>${param1}</strong>`)
      .replaceAll('{2}', `<strong>${param2}</strong>`)
      .replaceAll('{3}', `<strong>${param3}</strong>`)
      .replaceAll('{4}', `<strong>${param4}</strong>`)
      .replaceAll('{5}', `<strong>${param5}</strong`)
      .replaceAll('{6}', `<strong>${param6}</strong>`)
      .replaceAll(`Aero DMG`, `<strong class="Aero">Aero DMG</strong>`)
      .replaceAll(`Electro DMG`, `<strong class="Electro">Electro DMG</strong>`)
      .replaceAll(`Fusion DMG`, `<strong class="Fusion">Fusion DMG</strong>`)
      .replaceAll(`Glacio DMG`, `<strong class="Glacio">Glacio DMG</strong>`)
      .replaceAll(`Havoc DMG`, `<strong class="Havoc">Havoc DMG</strong>`)
      .replaceAll(`Spectro DMG`, `<strong class="Spectro">Spectro DMG</strong>`)
      .replaceAll(
        `Physical DMG`,
        `<strong class="Physical">Physical DMG</strong>`
      )
      .replaceAll(`\\n\\n`, `<br />`);
    setFinalEchoEffect(newString);
  }, [level, echo]);
  return (
    <>
      {inline ? (
        <>
          <CustomPopover
            enabled={true}
            customClass="character-hover-box ww"
            popover={
              <>
                <div className="character-popover ww">
                  <div className="ww-content">
                    <div
                      className={`ww-skill-with-coloring`}
                      dangerouslySetInnerHTML={{
                        __html: finalEchoEffect
                      }}
                    />
                  </div>
                </div>
              </>
            }
          >
            <div className={`ww-echo-inline`}>
              <div>
                <div className={`ww-echo-cost rar-${echo.Rarity}`}>
                  <WWEchoImage id={echo.ID} />
                </div>
                <div className={`ww-echo-name rar-${echo.Rarity}`}>
                  <span>{echo.Name}</span>
                </div>
              </div>
            </div>
          </CustomPopover>
        </>
      ) : (
        <>
          {onProfile ? (
            <Accordion className="ww-echo-accordion">
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  <div className={`ww-echo-cost rar-${echo.Rarity}`}>
                    <WWEchoImage id={echo.ID} />
                  </div>
                  <span className={`ww-echo-name rar-${echo.Rarity}`}>
                    {echo.Name}
                  </span>
                </Accordion.Header>
                <Accordion.Body>
                  <div className="ww-content">
                    <div
                      className={`skill-with-coloring`}
                      dangerouslySetInnerHTML={{
                        __html: finalEchoEffect
                      }}
                    />
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          ) : (
            <>
              <div className="ww-echo-box box">
                <div className="ww-header">
                  <div className={`ww-image rar-${level}`}>
                    <WWEchoImage id={echo.ID} />
                  </div>
                  <div className="ww-data">
                    <h4>
                      {echo.Name}{' '}
                      {echo.isNew && <span className="tag">New!</span>}
                    </h4>
                    <div className="ww-info">
                      <p>
                        Class:{' '}
                        <strong className={`rarity-ww rar-${echo.Rarity}`}>
                          {echo.Rarity === 0 && 'Common'}
                          {echo.Rarity === 1 && 'Elite'}
                          {echo.Rarity === 2 && 'Overlord'}
                          {echo.Rarity === 3 && 'Calamity'}
                        </strong>
                      </p>
                      <p>
                        Cost:{' '}
                        <strong className={`rarity-ww rar-${echo.Rarity}`}>
                          {echo.Rarity === 0 && '1'}
                          {echo.Rarity === 1 && '3'}
                          {echo.Rarity === 2 && '4'}
                          {echo.Rarity === 3 && '4'}
                        </strong>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="ww-content">
                  <div
                    className={`skill-with-coloring`}
                    dangerouslySetInnerHTML={{
                      __html: finalEchoEffect
                    }}
                  />
                </div>
                <div className="ww-sets">
                  Sets:
                  {echo.Sonata_Group.indexOf(1) > -1 && (
                    <div className="single-set Freezing">
                      <StaticImage
                        src="../../../images/ww/icons/set_1.webp"
                        alt="Set"
                      />
                    </div>
                  )}
                  {echo.Sonata_Group.indexOf(2) > -1 && (
                    <div className="single-set Molten">
                      <StaticImage
                        src="../../../images/ww/icons/set_2.webp"
                        alt="Set"
                      />
                    </div>
                  )}
                  {echo.Sonata_Group.indexOf(3) > -1 && (
                    <div className="single-set Void">
                      <StaticImage
                        src="../../../images/ww/icons/set_3.webp"
                        alt="Set"
                      />
                    </div>
                  )}
                  {echo.Sonata_Group.indexOf(4) > -1 && (
                    <div className="single-set Sierra">
                      <StaticImage
                        src="../../../images/ww/icons/set_4.webp"
                        alt="Set"
                      />
                    </div>
                  )}
                  {echo.Sonata_Group.indexOf(5) > -1 && (
                    <div className="single-set Celestial">
                      <StaticImage
                        src="../../../images/ww/icons/set_5.webp"
                        alt="Set"
                      />
                    </div>
                  )}
                  {echo.Sonata_Group.indexOf(6) > -1 && (
                    <div className="single-set Havoc">
                      <StaticImage
                        src="../../../images/ww/icons/set_6.webp"
                        alt="Set"
                      />
                    </div>
                  )}
                  {echo.Sonata_Group.indexOf(7) > -1 && (
                    <div className="single-set Rejuvenating">
                      <StaticImage
                        src="../../../images/ww/icons/set_7.webp"
                        alt="Set"
                      />
                    </div>
                  )}
                  {echo.Sonata_Group.indexOf(8) > -1 && (
                    <div className="single-set Moonlit">
                      <StaticImage
                        src="../../../images/ww/icons/set_8.webp"
                        alt="Set"
                      />
                    </div>
                  )}
                  {echo.Sonata_Group.indexOf(9) > -1 && (
                    <div className="single-set Endless">
                      <StaticImage
                        src="../../../images/ww/icons/set_9.webp"
                        alt="Set"
                      />
                    </div>
                  )}
                  {echo.Sonata_Group.indexOf(10) > -1 && (
                    <div className="single-set Frosty">
                      <StaticImage
                        src="../../../images/ww/icons/set_10.webp"
                        alt="Set"
                      />
                    </div>
                  )}
                  {echo.Sonata_Group.indexOf(11) > -1 && (
                    <div className="single-set Eternal">
                      <StaticImage
                        src="../../../images/ww/icons/set_11.webp"
                        alt="Set"
                      />
                    </div>
                  )}
                  {echo.Sonata_Group.indexOf(12) > -1 && (
                    <div className="single-set Midnight">
                      <StaticImage
                        src="../../../images/ww/icons/set_12.webp"
                        alt="Set"
                      />
                    </div>
                  )}
                  {echo.Sonata_Group.indexOf(13) > -1 && (
                    <div className="single-set Empyrean">
                      <StaticImage
                        src="../../../images/ww/icons/set_13.webp"
                        alt="Set"
                      />
                    </div>
                  )}
                  {echo.Sonata_Group.indexOf(14) > -1 && (
                    <div className="single-set Tidebreaking">
                      <StaticImage
                        src="../../../images/ww/icons/set_14.webp"
                        alt="Set"
                      />
                    </div>
                  )}
                  {echo.Sonata_Group.indexOf(15) > -1 && (
                    <div className="single-set Welkin">
                      <StaticImage
                        src="../../../images/ww/icons/set_15.webp"
                        alt="Set"
                      />
                    </div>
                  )}
                </div>
              </div>
            </>
          )}
        </>
      )}
    </>
  );
};
